module.exports = __webpack_public_path__ + "img/schnittkante_reinweiss_ral9010.2c64efcf.jpg";